// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum ChargeOrderStatus {
  Open = "OPEN",
  Paid = "PAID",
  Canceled = "CANCELED",
}
export default ChargeOrderStatus;

export function chargeOrderStatusToVariant(orderStatus: ChargeOrderStatus): string {
  switch (orderStatus) {
    case ChargeOrderStatus.Paid:
      return "success";

    case ChargeOrderStatus.Open:
      return "danger";

    case ChargeOrderStatus.Canceled:
      return "gray";
  }
}
